<template>
  <div class="layout-profile">
    
    <button class="p-link layout-profile-link" @click="onClick">
      <span class="username">{{ username }}</span>
      <i class="pi pi-fw pi-cog"></i>
    </button>
    <transition name="layout-submenu-wrapper">
      <ul v-show="expanded">
        <li>
          <router-link to="/empresas">
            <button class="p-link">
              <i class="pi pi-fw pi-user"></i><span>Lista de Empresas</span>
            </button>
          </router-link>
        </li>
        
        <li>
          <button class="p-link" @click="logout()">
            <i class="pi pi-fw pi-power-off"></i><span>Salir</span>
          </button>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    gNameuser: String,
  },
  data() {
    return {
      expanded: false,
      username: this.gNameuser,
    };
  },
  methods: {
    onClick(event) {
      this.expanded = !this.expanded;
      event.preventDefault();
    },
  },
};
</script>

<style scoped></style>
